import { FilterConfig}  from '../../../../model/filter';
import { Address, AddressGroup, Rule } from '../../../../dtos/version.dto';
import { isAddressGroupContainIpType, isAddressGroupHasRule } from '../../../../utils/versionUtils';

export const addressesGroupsFiltersConfig = (addresses: Address[], addressRules: Rule[]): FilterConfig<AddressGroup> => {
    return {
        searchBox: {placeholder: 'Search Address Group', byFields: ['displayName', 'description', 'addresses']},
        multipleDropdownList: [
            {
                name: 'Addresses',
                options:[
                    ...addresses.map(adr => {
                        return { key: adr.id, label: adr.displayName,
                            filterFn: (addressGroup: AddressGroup) => addressGroup.addresses.includes(adr.id)};
                    })
                ]
            },
            {
                name: 'Rules',
                matchWidth: false,
                options: [
                    ...addressRules.map(rule => {
                        return { key: rule.id, label: rule.displayName, filterFn: (addressGroup: AddressGroup) =>
                                isAddressGroupHasRule(rule, addressGroup) };
                    })
                ]
            }
        ],
        dropdownList: [
            {
                name: 'IP Type',
                options: [
                    { label: 'All', filterFn: () => true },
                    { label: 'IPv4', filterFn: (ag: AddressGroup) => isAddressGroupContainIpType(ag, addresses, 4) },
                    { label: 'IPv6', filterFn: (ag: AddressGroup) => isAddressGroupContainIpType(ag, addresses, 6) }
                ]
            }
        ]
    };
};